import type { FasceOrarie } from '../../../utility_objects/FasceOrarieUtils';

/**
 * Orari del calendario personale come li dà useUserHoursCalendar: per ogni
 * punto vendita dell'operatore ('keys') le fasce per giorno ('values').
 */
export interface OrariPersonaleServer {
  multi?: boolean;
  keys?: readonly string[];
  values?: Readonly<
    Record<
      string,
      Readonly<Record<string, FasceOrarie | null | undefined>> | undefined
    >
  >;
}

/**
 * Orari del calendario personale per giorno, 'YYYY-MM-DD' → le fasce di tutti
 * i punti vendita dell'operatore. È la banda che il Personale disegna: una
 * cella è in orario (codice 2 di isOpen, bianca o del colore del negozio con
 * più punti vendita) se cade in una fascia di uno qualunque dei punti vendita.
 * Le fasce passano tutte: quelle non valide le scarta chi le legge
 * (FinestraOraria scarta quelle con inizio non prima della fine). undefined
 * senza orari (in caricamento), come la mappa dell'agenda negozio.
 */
export function getOrariPersonale(
  calendarPerUser: OrariPersonaleServer | null | undefined
): Record<string, FasceOrarie[]> | undefined {
  if (!calendarPerUser) return undefined;
  const orari: Record<string, FasceOrarie[]> = {};
  for (const puntoVendita of calendarPerUser.keys ?? []) {
    const giorni = calendarPerUser.values?.[puntoVendita];
    if (!giorni) continue;
    for (const [giorno, fasce] of Object.entries(giorni)) {
      if (!fasce) continue;
      const delGiorno = orari[giorno] ?? [];
      delGiorno.push(fasce);
      orari[giorno] = delGiorno;
    }
  }
  return orari;
}
